import { render, staticRenderFns } from "./genralSettingsApproval.vue?vue&type=template&id=2a9039de&scoped=true"
import script from "./genralSettingsApproval.vue?vue&type=script&lang=js"
export * from "./genralSettingsApproval.vue?vue&type=script&lang=js"
import style0 from "./genralSettingsApproval.vue?vue&type=style&index=0&id=2a9039de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9039de",
  null
  
)

export default component.exports